import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Media } from "@is/components/Media";
import {
  LocalStorageKeys,
  MediaOrientation,
  MediaVariants,
  TranslationContext,
} from "@is/constants";
import { useScreenOrientation } from "@is/hooks";
import { LocalStorageService } from "@is/services";
import { sendErrorMessageToSlack } from "@is/utils/slack";

function useManageOfflineView() {
  const { t } = useTranslation(TranslationContext.General);
  const { isPortraitView } = useScreenOrientation();

  const backgroundMedia = JSON.parse(
    `${LocalStorageService.getItem(LocalStorageKeys.BackgroundMedia)}`
  );

  const mediaElement = useMemo(() => {
    const orientation = isPortraitView
      ? MediaOrientation.Vertical
      : MediaOrientation.Horizontal;

    const media =
      backgroundMedia?.[orientation] ??
      backgroundMedia[MediaOrientation.Vertical] ??
      backgroundMedia[MediaOrientation.Horizontal];

    return (
      <Media
        media={media}
        mediavariant={MediaVariants.HUGE}
        showloadingspinner
      />
    );
  }, [backgroundMedia, isPortraitView]);

  useEffect(() => {
    return () => {
      sendErrorMessageToSlack("Device was without internet connection");
    };
  }, []);

  return {
    mediaElement,
    t,
  };
}

export default useManageOfflineView;
